import { render, staticRenderFns } from "./DefaultContent-CustomerAccount.vue?vue&type=template&id=9750f6e4&"
import script from "./DefaultContent-CustomerAccount.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-CustomerAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports